<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="form-horizontal">
    <div class="form-group">
      <label>Amount</label>
      <input type="text" class="form-control" [(ngModel)]="amountValue" />
    </div>
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" (click)="save()" [disabled]="crudLoading">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
